import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { NotebookPermissionPage } from "models/interfaces/notebooks/notebook-permission-page";

const defaultValues: NotebookPermissionPage =
    RecordUtils.auditableDefaultValuesFactory<NotebookPermissionPage>({
        pageId: undefined,
        notebookResourcePermissionId: undefined,
    });

export default class NotebookPermissionPageRecord
    extends Record(defaultValues)
    implements NotebookPermissionPage
{
    constructor(params?: Partial<NotebookPermissionPage>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public with(
        values: Partial<NotebookPermissionPage>
    ): NotebookPermissionPageRecord {
        return new NotebookPermissionPageRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
